module.exports = __webpack_public_path__ + "img/3.bfee0a89.png";